import {Component, inject, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {NgOptimizedImage} from "@angular/common";
import {SubtitlesService} from "../../../core";

@Component({
    selector: 'form-text-input',
    standalone: true,
    imports: [NgOptimizedImage, ReactiveFormsModule],
    templateUrl: './form-text-input.component.html',
    styleUrl: './form-text-input.component.scss'
})
export class FormTextInputComponent {
    protected readonly subtitles = inject(SubtitlesService);

    readonly inputControl = input.required<FormControl>();
    readonly placeholder = input.required<string>();
    readonly telType = input(false);
    readonly id = input<string>();
    readonly maxLength = input(255);

    protected isInvalid(): boolean {
        const control = this.inputControl();
        return control.invalid && (control.dirty || control.touched);
    }
}
